import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceingeomevalllely() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Genome Valley Hyderabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Genome Valley Hyderabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Genome Valley Hyderabad, catering to the transportation needs of biotech companies, research centers, corporate offices, and industrial units in the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Genome Valley Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic landmark, built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand square-shaped monument features four towering minarets and intricate Islamic architecture. Surrounded by bustling bazaars, street food vendors, and shops selling pearls, bangles, and traditional crafts, Charminar is a cultural and historical hub, attracting tourists from across India and the world."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress located on the outskirts of Hyderabad, known for its massive walls, impressive gateways, and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it offers panoramic views of the city and nearby hills. The evening light and sound show narrates the fort’s rich history, making it a favorite destination for history enthusiasts and photographers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake in the heart of Hyderabad, famous for the gigantic Buddha statue standing on Gibraltar Rock in the middle of the water. The lake is popular for boating, evening walks, and lakeside leisure. Surrounded by parks, eateries, and promenades, it serves as a serene escape and recreational spot for locals and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing an extensive collection of art, sculptures, manuscripts, and artifacts from India and around the world. Visitors can explore centuries of history and culture through exhibits such as Mughal miniatures, European paintings, and decorative arts. The museum provides an immersive educational experience for art and history enthusiasts."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the world’s largest film studio complexes and a popular entertainment destination near Hyderabad. Spread across thousands of acres, it features film sets, amusement rides, gardens, and live shows. Visitors can enjoy guided tours, interactive experiences, and cultural performances, making it a top choice for family outings and film enthusiasts."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning 18th-century palace that once served as the seat of the Nizams of Hyderabad. The complex features grand halls, intricate interiors, beautiful courtyards, and royal artifacts. Visitors can explore the opulent architecture and learn about the history and lifestyle of the Nizams, making it a cultural and historical gem of the city."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara, located on a hill overlooking Hyderabad. The temple offers panoramic views of the city and the lake below. Visitors can admire the detailed carvings, serene surroundings, and participate in spiritual rituals, making it a peaceful retreat in the heart of the city."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s famous shopping street, known for its vibrant bangles, jewelry, pearls, textiles, and handicrafts. The bustling markets and colorful storefronts create an authentic local experience. It is a must-visit for tourists looking to shop, explore, and enjoy the vibrant culture of the old city."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard along Hussain Sagar Lake, popular for evening walks, recreational activities, and lakeside dining. It features landscaped gardens, jogging tracks, and food stalls. The area is ideal for leisure, family outings, and enjoying the illuminated view of the Buddha statue on the lake."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are the royal necropolis of the Qutb Shahi dynasty, located near Golconda Fort. The complex features grand domed tombs, landscaped gardens, and intricate stonework. Visitors can explore the historical architecture, learn about the dynasty’s legacy, and enjoy peaceful walks amidst the ancient structures."
  }
],


"services": [
  {
    "name": "Genome Valley Pharma Industrial Cab",
    "description": "Genome Valley Pharma Industrial Cab provides dedicated transportation services for employees, researchers, and executives commuting to Genome Valley's pharmaceutical and biotech parks. With a fleet of sedans, SUVs, and shuttles, the service ensures timely, safe, and efficient transportation with route optimization, professional chauffeurs, and GPS-enabled tracking for enhanced convenience and security."
  },
  {
    "name": "Biotech Park Employee Transport",
    "description": "Biotech Park Employee Transport offers specialized transport solutions for employees working in the Genome Valley Biotech Park. This service includes scheduled pickups, optimized routes, and real-time tracking to ensure employees travel safely and efficiently to and from the park. The fleet consists of modern vehicles equipped with comfort and safety features to meet the needs of the biotech sector."
  },
  {
    "name": "Corporate Shuttle Genome Valley",
    "description": "Corporate Shuttle Genome Valley provides high-capacity shuttle services designed for large-scale workforce transportation within Genome Valley's pharmaceutical and research hubs. Featuring AC minibuses, optimized routing, and real-time tracking, it ensures seamless and punctual employee transport, supporting multi-shift operations and high-volume staff transfers across the park."
  },
  {
    "name": "Staff Pickup Drop Genome Valley",
    "description": "Staff Pickup Drop Genome Valley offers pre-scheduled, reliable transportation solutions for employees working in various facilities within Genome Valley. This service ensures employees are picked up and dropped off at designated points on time, with fixed routes, professional drivers, and GPS-enabled tracking to guarantee safety and punctuality."
  },
  {
    "name": "Monthly Cab Genome Valley",
    "description": "Monthly Cab Genome Valley offers contract-based employee transportation for companies operating in Genome Valley. With dedicated vehicles, trained drivers, and route optimization, the service ensures consistent and uninterrupted transport throughout the month, offering predictable pricing, professional chauffeurs, and seamless daily commuting solutions for organizations."
  },
  {
    "name": "Best Corporate Cab Genome Valley",
    "description": "Best Corporate Cab Genome Valley offers premium transportation services for executives, researchers, and VIP clients traveling within Genome Valley. Featuring high-end sedans and SUVs with experienced chauffeurs, the service delivers a refined, punctual, and comfortable travel experience tailored to the needs of corporate professionals and business visitors."
  },
  {
    "name": "Affordable Cab Genome Valley",
    "description": "Affordable Cab Genome Valley provides budget-friendly transport options for employees and companies working in Genome Valley. With efficient routing, clean vehicles, and trained drivers, the service ensures safe and reliable daily commuting at an affordable price point, catering to startups, SMEs, and biotech companies."
  },
  {
    "name": "Outstation Cab Genome Valley",
    "description": "Outstation Cab Genome Valley offers long-distance transportation solutions for business trips, client meetings, and executive travel. Featuring sedans and SUVs, the service ensures safe, comfortable, and efficient outstation mobility, with experienced chauffeurs, route planning, and real-time tracking to facilitate smooth interstate travel for businesses in Genome Valley."
  },
  {
    "name": "Sedan Cab Genome Valley",
    "description": "Sedan Cab Genome Valley provides premium sedans for executives and employees requiring refined transportation. The service is ideal for managerial travel, client visits, and business meetings within Genome Valley. Well-maintained sedans, professional drivers, and a focus on comfort and punctuality make it a seamless travel experience."
  },
  {
    "name": "SUV Cab Genome Valley",
    "description": "SUV Cab Genome Valley offers spacious, high-performance SUVs for senior executives, team travel, and long-distance business trips. The fleet is equipped with advanced safety features, comfortable interiors, and driven by professional chauffeurs to ensure a premium and reliable travel experience for all corporate clients."
  },
  {
    "name": "Company Cab Genome Valley",
    "description": "Company Cab Genome Valley provides full-service employee transport solutions, including fleet management, driver services, and route optimization for companies operating within Genome Valley. This service is ideal for businesses seeking a reliable and scalable transport solution to manage their workforce's daily commuting needs."
  },
  {
    "name": "Research Park Transport",
    "description": "Research Park Transport offers dedicated shuttle and cab services for employees and visitors commuting to and from Genome Valley's research parks. With a fleet of vehicles that include shuttles, SUVs, and sedans, the service ensures efficient, timely, and safe transportation, supporting a diverse range of researchers, scientists, and technical staff."
  },
  {
    "name": "Employee Mobility Genome Valley",
    "description": "Employee Mobility Genome Valley provides comprehensive workforce transportation solutions tailored to the needs of companies within Genome Valley. The service includes route planning, multi-shift support, real-time monitoring, and fleet management to ensure smooth, consistent, and reliable employee movement throughout the industrial park."
  },
  {
    "name": "Corporate Fleet Genome Valley",
    "description": "Corporate Fleet Genome Valley offers end-to-end fleet outsourcing services for companies operating in Genome Valley. With sedans, SUVs, and shuttle buses, the service includes vehicle maintenance, driver management, route optimization, and safety compliance, ensuring scalable and reliable transportation for businesses of all sizes."
  },
  {
    "name": "Business Cab Genome Valley",
    "description": "Business Cab Genome Valley provides premium transportation for executives, clients, and business visitors traveling to Genome Valley. Featuring luxury sedans and SUVs with experienced chauffeurs, the service ensures punctuality, comfort, and seamless travel for high-level professionals attending meetings, conferences, and business events."
  }
],

"tableData": [
  ["Genome Valley Pharma Industrial Cab", "Biotech Park Employee Transport"],
  ["Corporate Shuttle Genome Valley", "Staff Pickup Drop Genome Valley"],
  ["Monthly Cab Genome Valley", "Best Corporate Cab Genome Valley"],
  ["Affordable Cab Genome Valley", "Outstation Cab Genome Valley"],
  ["Sedan Cab Genome Valley", "SUV Cab Genome Valley"],
  ["Company Cab Genome Valley", "Research Park Transport"],
  ["Employee Mobility Genome Valley", "Corporate Fleet Genome Valley"],
  ["Business Cab Genome Valley", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Genome Valley Hyderabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Genome Valley Hyderabad, ensuring smooth and efficient transportation for employees and business executives in the biotech and industrial hubs."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Genome Valley’s corporate, biotech, and industrial facilities, helping employees reach work and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs offer safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel in Genome Valley."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored cab rental plans to meet the commuting needs of companies and employees in Genome Valley Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking process and reliable coordination, making employee transport hassle-free."
  }
]


































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Genome Valley, Hyderabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and biotech offices located in Genome Valley, Hyderabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Genome Valley?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and full fleet management solutions for biotech and corporate offices.',
  },
  {
    question: 'Do you support daily employee commute services in Genome Valley?',
    answer: 'Yes, we offer optimized daily commute services with timely pickups, route planning, and multi-shift transportation for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Genome Valley?',
    answer: 'Companies can book via our website, mobile app, or by contacting our 24×7 corporate support team for seamless scheduling.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Genome Valley?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Genome Valley?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All our vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs for employee safety.',
  },
  {
    question: 'Do you support night shift and rotational shift employee transportation in Genome Valley?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and also offer consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pranav Deshmukh',
    feedback: 'Highly professional corporate cab service in Genome Valley. Punctual drivers and well-maintained vehicles make employee commuting easy.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Divya Reddy',
    feedback: 'Our employees rely on their dependable daily commute services. Excellent coordination and smooth service every day.',
    rating: 5,
  },
];










































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Genome Valley Hyderabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-genome-valley.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers specialized corporate cab services in Genome Valley Hyderabad, covering pharma and biotech industrial transport, employee shuttle services, staff pickup & drop, research park cab services, monthly corporate cab plans, outstation travel, and complete fleet solutions for companies in the Genome Valley region.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-genome-valley-hyderabad"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Genome Valley Hyderabad | Pharma & Biotech Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Genome Valley Hyderabad including pharma industrial transport, biotech park employee mobility, corporate shuttle, staff pickup & drop, monthly cab services, business cabs, and outstation travel solutions."
  />

  <meta
    name="keywords"
    content="Genome Valley Pharma Industrial Cab, Biotech Park Employee Transport, Corporate Shuttle Genome Valley, Staff Pickup Drop Genome Valley, Monthly Cab Genome Valley, Best Corporate Cab Genome Valley, Affordable Cab Genome Valley, Outstation Cab Genome Valley, Sedan Cab Genome Valley, SUV Cab Genome Valley, Company Cab Genome Valley, Research Park Transport, Employee Mobility Genome Valley, Corporate Fleet Genome Valley, Business Cab Genome Valley"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceingeomevalllely;